module.exports = __webpack_public_path__ + "static/img/function1.fcee00e3.png";